module.exports = __webpack_public_path__ + "static/img/app5@2x.d2d874e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/app5@2x.png
// module id = nJwI
// module chunks = 2